// Authentication service using AWS Amplify
import { Amplify } from 'aws-amplify';
import { signUp, confirmSignUp, signIn, signOut, getCurrentUser, resetPassword, confirmResetPassword, fetchAuthSession } from 'aws-amplify/auth';

// Configure the authentication
export const configureAuth = (config: {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
}) => {
  Amplify.configure({
    // Configure Auth category
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolWebClientId,
        loginWith: {
          email: true
        },
        region: config.region
      }
    }
  });
};

// Re-export the functions with our error handling
export { signUp, signIn, signOut, getCurrentUser };

// Confirm sign up with verification code
export const confirmSignUpWithCode = async (username: string, code: string): Promise<any> => {
  try {
    return await confirmSignUp({ username, confirmationCode: code });
  } catch (error) {
    console.error('Error confirming sign up:', error);
    throw error;
  }
};

// Get the current session
export const getCurrentSession = async (): Promise<any> => {
  try {
    return await fetchAuthSession();
  } catch (error) {
    console.error('Error getting current session:', error);
    return null;
  }
};

// Get JWT token
export const getIdToken = async (): Promise<string | null> => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || null;
  } catch (error) {
    console.error('Error getting ID token:', error);
    return null;
  }
};

// Reset password
export const forgotPassword = async (username: string): Promise<any> => {
  try {
    return await resetPassword({ username });
  } catch (error) {
    console.error('Error requesting password reset:', error);
    throw error;
  }
};

// Complete password reset
export const forgotPasswordSubmit = async (
  username: string,
  code: string,
  newPassword: string
): Promise<any> => {
  try {
    return await confirmResetPassword({
      username,
      confirmationCode: code,
      newPassword
    });
  } catch (error) {
    console.error('Error submitting new password:', error);
    throw error;
  }
};

// Update user attributes
export const updateUserAttributes = async (attributes: Record<string, string>): Promise<any> => {
  try {
    // This would need to be implemented using the new Amplify API
    console.error('updateUserAttributes is not implemented with new Amplify API');
    throw new Error('Not implemented');
  } catch (error) {
    console.error('Error updating user attributes:', error);
    throw error;
  }
};


// Add a fallback configuration for development
export const configureDevelopmentAuth = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_NQdhW13se', // Replace with your actual userPoolId
        userPoolClientId: '1mdgrks6oeab5oi1egar5bnj5m', // Replace with your actual clientId
        region: 'us-east-1'
      }
    }
  });
};